import { SidebarContent } from './SidebarContent'

/**
 * Sidebar fixa do desktop (≥ lg). No mobile (< 1024px) ela some — quem
 * exibe o menu é o `<MobileSidebarDrawer>` controlado pelo hambúrguer do
 * `<Header>`. Ambos compartilham o `<SidebarContent>`.
 */
export function Sidebar() {
  return (
    <aside className="hidden h-screen w-64 flex-col border-r border-border bg-sidebar lg:flex">
      <SidebarContent />
    </aside>
  )
}
